import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Icon as AIcon,
  Radio,
  Tooltip,
  Dropdown,
  Menu,
  Input
} from "antd"
import { MoreIcon, CheckedIcon } from "../core/icons"
import Line from "../core/Line"

import Card, { TitleCard, CardHeader } from "../core/Card"
import { getPlans, getInvoices } from "./actions"
import onMount from "../core/onMount"
import twix from "twix"
import moment from "moment"
import numeral from "numeral"

import Features from "./Features"
import Plans from "./Plans"
import FAQ from "./FAQ"
import ConnectedPlan from "./ConnectedPlan"
import PremiumFeatures from "./PremiumFeatures"

import TeamsUpsellPanel from "./TeamsUpsellPanel"
import GroupDiscountPanel from "./GroupDiscountPanel"
import PotentialCredits from "./PotentialCredits"
import Invoices from "./Invoices"
import "./Premium.css"
import Button from "./"

import styled from "styled-components"

const New = props => (
  <div>
    <TitleCard>
      <h1>
        Upgrade to
        {props.isTeamOwner ? (
          <span style={{ color: "#31B59F" }}> Everlance Teams</span>
        ) : (
          " Everlance Premium"
        )}
      </h1>
    </TitleCard>

    <GroupDiscountPanel user={props.user} />

    <TeamsUpsellPanel user={props.user} />

    <PotentialCredits />

    <Plans />

    <Features
      isTeams={props.isTeamOwner}
      isAndroid={props.user.android_device_model}
    />

    <Card>
      <PremiumFeatures />
    </Card>

    <FAQ />
  </div>
)

const mapStateToProps = (state, ownProps) => {
  const { plans, invoices, user } = state.models
  const { subs } = state
  return {
    invoices,
    isFetching: user.isFetching,
    isFetchingInvoices: subs.isFetchingInvoices,
    hasSubscription: user.hasSubscription,
    user,
    isTeamOwner: !!state.models.user.group_as_enterprise_owner
  }
}

export default connect(mapStateToProps)(
  onMount(({ dispatch }) => {
    // dispatch(getPlans())
    // dispatch(getInvoices())
  })(New)
)



// WEBPACK FOOTER //
// ./src/subscriptions/New.js